import { useEffect, useState } from "react";

import { getActiveBanners } from "@/services/supabase/banners";
import { hasSupabaseConfig } from "@/services/supabase/client";
import { BannerPlacement, PortalBanner } from "@/services/supabase/types";

const DEFAULT_BANNERS: PortalBanner[] = [];

export const usePortalBanners = (placement: BannerPlacement) => {
  const [banners, setBanners] = useState<PortalBanner[]>(DEFAULT_BANNERS);
  const [isLoading, setIsLoading] = useState(hasSupabaseConfig);

  useEffect(() => {
    if (!hasSupabaseConfig) {
      setBanners(DEFAULT_BANNERS);
      setIsLoading(false);

      return;
    }

    let isMounted = true;

    const fetchBanners = async () => {
      try {
        setIsLoading(true);
        const data = await getActiveBanners({
          placements: ["global", placement],
        });

        if (isMounted) {
          setBanners(data);
        }
      } catch {
        if (isMounted) {
          setBanners(DEFAULT_BANNERS);
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    void fetchBanners();

    return () => {
      isMounted = false;
    };
  }, [placement]);

  return {
    banners,
    isLoading,
  };
};
